import { z } from 'zod';

export const lessonProgressesSchema = z.object({
  documentId: z.nullable(z.string()), // lesson documentId
  current_second: z.number(),
  progress_status: z.string(),
});

export const lessonsSchema = z.array(
  z.object({
    documentId: z.string(),
    title: z.nullable(z.string()),
    description: z.nullable(z.string()),
    duration: z.nullable(z.number()),
    playbackId: z.nullable(z.string()),
    free: z.nullable(z.boolean()),
    teacherProfiles: z.nullable(
      z.array(
        z.nullable(
          z.object({
            displayName: z.nullable(z.string()),
            mainSubject: z.nullable(z.string()),
            profilePicture: z.nullable(z.object({ url: z.nullable(z.string()) })),
          }),
        ),
      ),
    ),
    thumbnail: z.object({
      url: z.nullable(z.string()),
    }),
    lessonProgresses: z.array(lessonProgressesSchema),
  }),
);

export type Lessons = z.infer<typeof lessonsSchema>;
export type LessonProgresses = z.infer<typeof lessonProgressesSchema>;
